import { IHeadlineHookProps, IPartial } from './types';

export function useHeadline({ data, onUpdate }: IHeadlineHookProps) {
  const { headline = '', subheadline = '', template, mountNodeId, isCenter = false } = data.data;

  const isLandingV2 = template === 'landingV2';

  const handleHeadlineChange = (headline: string) => {
    handleChange({ headline });
  };

  const handleSubheadlineChange = (subheadline: string) => {
    handleChange({ subheadline });
  };

  const handleChange = (partial: IPartial) => {
    const newObject = {
      ...data,
      data: {
        ...data.data,
        ...partial,
      },
    };

    // @ts-ignore
    onUpdate(newObject);
  };

  return {
    headline,
    subheadline,
    isLandingV2,
    mountNodeId,
    handleHeadlineChange,
    handleSubheadlineChange,
    isCenter,
  };
}
